import { InterfaceLanguage } from '../../enums/interface-language';

export const DEFAULT_INTERFACE_LANGUAGE = InterfaceLanguage.PL;
